import React from 'react';
import styled from 'styled-components';

const StyledBlockWrapper = styled.section`
  margin: 5rem 0;
  color: var(--color-text-light);

  @media (${({ theme }) => theme.respondTo.desktop}) {
    margin: 5rem 0;
  }

  ${({ grayBackground }) =>
    grayBackground &&
    `
    color: var(--color-text-dark);
    background: var(--color-light-gray);
    padding: 7rem 0 6rem;
    margin: 0;
  `}

  @media (${({ theme }) => theme.respondTo.desktop}) {
    ${({ grayBackground }) =>
      grayBackground &&
      `
      position: relative;
      padding: 26rem 0;
      margin: 0;
    `}
  }
`;

const RoundedWrapper = styled.div`
  width: 100%;
  height: 19.5rem;
  background: var(--color-primary);
  border-radius: 0 0 0 20rem;
  position: absolute;
  top: 0;

  ${({ borderRight }) =>
    borderRight &&
    `
    border-radius: 0 20rem 0 0;
    top: auto;
    bottom: 0;
  `}

  @media (${({ theme }) => theme.respondTo.tabletAndMobile}) {
    display: none;
  }
`;

const BlockWrapper = ({ grayBackground, children }) => {
  return (
    <StyledBlockWrapper grayBackground={grayBackground}>
      {children}
      {grayBackground && (
        <>
          <RoundedWrapper />
          <RoundedWrapper borderRight />
        </>
      )}
    </StyledBlockWrapper>
  );
};

export default BlockWrapper;
